import { defineComponent as _defineComponent } from 'vue'
import { Placeholder } from '../../VariantsConfigurator/typings';


export default /*#__PURE__*/_defineComponent({
  __name: 'PlaceholderSize',
  props: {
    placeholder: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})